import { render } from "./latestNotification.vue?vue&type=template&id=b0929ba2"
import script from "./latestNotification.vue?vue&type=script&lang=js"
export * from "./latestNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__